import _asyncToGenerator from "C:/GitLab-Runner/builds/VgMjNYji/0/billing/billingmalta/src/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { EntityQuery } from '@cime/breeze-client';
import { ErrorDialogComponent } from '@common/components/error-dialog.component';
import _ from 'lodash';
import { firstValueFrom, of, Subject } from 'rxjs';
import { catchError, debounceTime, filter, first, timeout } from 'rxjs/operators';
import { AbstractBreezeListComponent } from './breeze-list';
export class AutoFilterBreezeListComponent extends AbstractBreezeListComponent {
  constructor(breezeViewService, sharedService, modalService = null, dialogService = null) {
    var _this;
    super(breezeViewService);
    _this = this;
    this.breezeViewService = breezeViewService;
    this.sharedService = sharedService;
    this.modalService = modalService;
    this.dialogService = dialogService;
    this.autoFilterChanged = new Subject();
    this.fetchAllVesselNames = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (filter) {
        return (yield _this.breezeViewService.entityManager.executeQuery(new EntityQuery('AllVesselNames').withParameters({
          $method: 'POST',
          $data: {
            filter
          }
        }))).results;
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    this.autoFilterChanged.pipe(debounceTime(500)).subscribe(() => super.search());
    this.tabSelected = _.debounce(this.tabSelected.bind(this), 100);
  }
  onAutoFilterChange(event) {
    this.autoFilterChanged.next(this.filter);
  }
  tabSelected(select) {
    var _superprop_getTabSelected = () => super.tabSelected,
      _superprop_getSearch = () => super.search,
      _this2 = this;
    return _asyncToGenerator(function* () {
      firstValueFrom(_this2.sharedService.sendData$.pipe(filter(res => res === false), first(), timeout(1000), catchError(() => of(false)))).finally(() => {
        _this2.activeTab = select.index;
        _this2.filter.archived = select.index === 1;
        _this2.selection = [];
        _superprop_getTabSelected().call(_this2, select);
        _superprop_getSearch().call(_this2, null, true);
      });
    })();
  }
  executeAndHandle(queryName, command, title = '', extra = '') {
    const entity = queryName.replace(/([a-z])([A-Z])/g, '$1 $2');
    const data = {};
    const invoicesCount = _.isEmpty(this.selection) ? this.appGrid.internalData.total : this.selection.length;
    data.query = this.breezeService.convertToDto(this.filter);
    data.query.ids = this.selection;
    this.dialogService.confirm(this.translateService.instant(title), `${this.translateService.instant(`Are you sure you want ${title} ${entity}`)} (${invoicesCount})?${extra ? ' ' + extra : ''}`).then(result => {
      if (result !== true) return;
      this.breezeViewService.handleCommand(command, {
        ids: this.selection
      }).then(res => {
        if (res?.length > 0) this.handleSingleError(res[0]);
      }).catch(error => this.handleErrorList(error)).finally(() => {
        if (title === 'Archive') this.selection = [];
        super.search(this.appGrid.destructureUrlStateParams());
      });
    });
  }
  executeAndHandleSetColor(queryName, ids, colorId) {
    const entity = queryName.replace(/([a-z])([A-Z])/g, '$1$2');
    this.breezeViewService.handleCommand(`Set${entity}Color`, {
      ids,
      colorId
    }).then(res => {
      if (res?.length > 0) this.handleSingleError(res[0]);
    }).catch(error => this.handleErrorList(error)).finally(() => this.search(this.appGrid.destructureUrlStateParams()));
  }
  handleErrorList(error) {
    const dialogRef = this.modalService.open(ErrorDialogComponent, {
      size: 'lg'
    });
    dialogRef.componentInstance.isServerSideError = true;
    dialogRef.componentInstance.setMessage(error?.error.errorMessage);
  }
  handleSingleError(error) {
    const dialogRef = this.modalService.open(ErrorDialogComponent, {
      size: 'lg'
    });
    dialogRef.componentInstance.isServerSideError = true;
    dialogRef.componentInstance.setMessage(error);
  }
}